import { render } from "./multimedia-record.vue?vue&type=template&id=37c8acee&scoped=true"
import script from "./multimedia-record.vue?vue&type=script&lang=js"
export * from "./multimedia-record.vue?vue&type=script&lang=js"

import "./multimedia-record.vue?vue&type=style&index=0&id=37c8acee&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c8acee"]])

export default __exports__